import { reportOnce } from '@protector/api-client';
import type { Dictionary } from '@protector/utils/types';
import { createSelector } from 'reselect';
import type { AppState } from '../../__legacy__/redux.types.ts';
import { hasRTRPlanEntitlement } from '../../company/__legacy__/redux.selectors.ts';
import { getSelectedPropertyId } from '../../core/__legacy__/redux.selectors.ts';
import type { Property } from '../models.ts';
import { entity } from './redux.reducer.ts';

const { selectAll, selectEntities } = entity.getSelectors();

const hasSeasons = (property: Property | undefined): boolean => Boolean(property?.seasons?.length);

export const selectPropertyEntities = createSelector(
  (state: AppState) => selectEntities(state.entities.property),
  (state: AppState) => hasRTRPlanEntitlement(state),
  (state: AppState) => selectAll(state.entities.property),
  (propertiesById, showPropertiesWithoutSeasons, properties) => {
    if (showPropertiesWithoutSeasons) {
      return propertiesById;
    }

    const mutableWithSeason: Dictionary<Property> = {};

    for (const property of properties) {
      if (property && property.seasons === undefined) {
        reportOnce(
          'property.__legacy__.redux.selectors:selectPropertyEntities',
          () => new Error('property.__legacy__.redux.selectors: property.seasons missing -- selectPropertyEntities is dropping properties'),
          { errorType: 'StateFallback', domain: 'Property', propertyId: property.id }
        );
      }
      if (hasSeasons(property)) {
        mutableWithSeason[property.id] = property;
      }
    }

    return mutableWithSeason;
  }
);
export const getSelectedProperty = createSelector(selectPropertyEntities, getSelectedPropertyId, (properties, selectedProperty) => {
  if (!selectedProperty) return;
  return properties[selectedProperty];
});
